import { Card, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleHistoryEmergencyAlarms } from '../../api/Services';
import DataTable from '../../components/table/DataTable';
import { EmergencyAlarmHistoryHeader } from '../../utils/Headers';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../logs/contand';
import { DEFAULT_ALARM_MANAGEMENT_HISTORY_STATE } from './constant';
import AlarmManagementHistoryHeader from './header/AlarmManagementHistoryHeader';
import AlarmManagementHistoryModal from './modal/AlarmManagementHistoryModal';
import moment from 'jalali-moment';
import useCalendar from '../../hooks/useCalendar';

const AlarmManagementHistory = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [state, setState] = useState(DEFAULT_ALARM_MANAGEMENT_HISTORY_STATE);
  const calendar = useCalendar();
  const isGregorianOrJalali = (date = '1402-10-06T23:59:59.000+03:30') => {
    const convert = +date.slice(0, 4);
    if (convert > 2000) {
      return false;
    } else {
      return true;
    }
  };
  const handleResetForm = () => {
    form.resetFields();
    form.setFieldsValue({
      sort: 'DESC',
    });
    setState(DEFAULT_ALARM_MANAGEMENT_HISTORY_STATE);
    handleGetAlarmManagementHistoryData(
      DEFAULT_ALARM_MANAGEMENT_HISTORY_STATE?.info,
    );
  };
  useEffect(() => {
    handleGetAlarmManagementHistoryData();
  }, [state.info]);

  const handleGetAlarmManagementHistoryData = async (info) => {
    const params = {
      ...state.info,
      startDate:
        calendar && isGregorianOrJalali(state.startDate)
          ? moment(state.startDate, 'jYYYY-jMM-jDD HH:mm:ss.SSSZ').format(
              'YYYY-MM-DDTHH:mm:ss.SSSZ',
            )
          : state.startDate,

      endDate:
        calendar && isGregorianOrJalali(state.endDate)
          ? moment(state.endDate, 'jYYYY-jMM-jDD HH:mm:ss.SSSZ').format(
              'YYYY-MM-DDTHH:mm:ss.SSSZ',
            )
          : state.endDate,
    };
    try {
      const { data } = await handleHistoryEmergencyAlarms(params);
      setState({
        ...state,
        // info: info,
        events: data?.result?.list,
        total: data?.result?.total,
        current: data?.result?.currentPage,
        loading: false,
        showFilterModal: false,
      });
    } catch (ex) {
      console.log(ex);
      setState({ ...state, loading: false });
    }
  };

  const getPag = (current, limit) => {
    console.log(state);
    setState({
      ...state,
      info: { ...state.info, page: current, limit },
    });
    // setState((prevState) => {
    //   const today = dayjs().format('YYYY-MM-DD');
    //   const updatedInfo = {
    //     ...prevState.info,
    //     startDate: prevState.info?.startDate || `${today}T00:00:00.000+03:30`,
    //     endDate: prevState.info?.endDate || `${today}T23:59:59.000+03:30`,
    //     page: current,
    //     limit,
    //   };

    //   console.log(updatedInfo);
    //   handleGetAlarmManagementHistoryData(updatedInfo);

    //   return {
    //     ...prevState,
    //     info: updatedInfo, // Ensuring all required fields exist
    //   };
    // });
  };

  const [scrollHeight, setScrollHeight] = useState(500);

  useEffect(() => {
    const updateScrollHeight = () => {
      setScrollHeight(window.innerHeight < 800 ? 400 : 500);
    };

    updateScrollHeight(); // Initialize on load
    window.addEventListener('resize', updateScrollHeight);

    return () => window.removeEventListener('resize', updateScrollHeight);
  }, []);
  return (
    <>
      <Card className="rounded-t-3xl">
        <AlarmManagementHistoryHeader
          onBack={() => navigate('/alarm-event')}
          handleResetForm={handleResetForm}
          state={state}
          setState={setState}
        />
      </Card>
      <Card className="rounded-b-3xl w-full h-[75vh] ">
        <DataTable
          dataSource={state.events || []}
          header={EmergencyAlarmHistoryHeader()}
          pagination={{
            position: ['none', 'bottomLeft'],
            total: state?.total,
            onChange: (current, limit) => {
              // console.log(current);
              getPag(current, limit);
            },
            current: state?.current || DEFAULT_PAGINATION_PAGE,
            pageSize: state.info?.limit || DEFAULT_PAGINATION_LIMIT,
          }}
          scroll={scrollHeight}
          loading={state.loading}
        />
      </Card>
      <AlarmManagementHistoryModal
        state={state}
        setState={setState}
        form={form}
        handleGetAlarmManagementHistoryData={
          handleGetAlarmManagementHistoryData
        }
      />
    </>
  );
};

export default AlarmManagementHistory;
